// External Libraries
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { PrimeTemplate } from 'primeng/api';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastService } from '../../../services/toast-messages/toast-messages.service';
import { FileUploaderComponent } from '../../../components/file-uploader/file-uploader.component';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-web-capture-upload',
  templateUrl: './web-capture-upload.component.html',
  styleUrls: ['./web-capture-upload.component.scss'],
  imports: [FileUploaderComponent, Toast, PrimeTemplate, TranslatePipe]
})
export class WebCaptureUploadComponent implements OnInit {
  private toastService = inject(ToastService);
  private router = inject(Router);

  tenantId: string = '';

  /**
   * Initializes the component by setting up the tenant ID
   *
   * Retrieves the tenant ID from local storage for document upload operations
   */
  ngOnInit(): void {
    this.tenantId = localStorage.getItem('tenantId') || '';
  }

  /**
   * Hands the uploaded documents off to the filing route.
   *
   * The document IDs are passed through router navigation state.
   * @param {string[]} docIds - Array of document IDs to be filed
   */
  startAdHocFiling(docIds: string[]) {
    this.router.navigate(['/webcapture/documentupload'], { state: { docIds } });
  }

  /**
   * Handles document upload errors by displaying an error toast
   * @param {string} error - The error message received from the upload process
   */
  handleDocumentUploadError(error: string) {
    this.toastService.error('Error', error, 5000, 'errorToast');
  }
}
